import { DataObject } from '@shared/models/data-object.model';
import { IUser } from '@shared/models/iuser.model';

/**
 * Function type that receives a record and userInfo as optional and returns
 * true/false.
 */
export type RecordEditableChecker = (record: DataObject, userInfo?: IUser) => boolean;

/**
 * Dictionary of RecordEditableChecker
 * Add here rules for a given record that should be marked as non editable
 * depending on its' values.
 */
export const RecordEditableCheckerMap: { [key: string]: RecordEditableChecker } = Object.freeze({});
